module.exports = __webpack_public_path__ + "static/media/inversor.84c17b4b.png";